import React from 'react';

import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import Instagram from '../Homepage/Instagram/Instagram';
import ContentThumbnail from '../Homepage/ContentThumbnail/ContentThumbnail';
import BrandHashtag from '../Homepage/BrandHashtag/BrandHashtag';

import placeholder01 from '../Homepage/ContentThumbnail/assets/placeholder-01.jpg';
import placeholder03 from '../Homepage/ContentThumbnail/assets/placeholder-03.jpg';
import placeholder04 from '../../assets/images/placeholder-04.png';
import videoAli from '../../assets/videos/ali.mp4';
import videoDamari from '../../assets/videos/damari.mp4';
import glitch from '../../assets/images/glitch.gif';
import bounce from '../../assets/images/bounce.gif';

import './styles/App.scss';

export default (props) => {
  return (
    <div className="App">
      <Nav />

      <div className="App-cols">
        
        <div className="App-col">
          <ContentThumbnail
            href="https://www.uninterrupted.com/watch/NKTipcLE/growing-up-in-the-nba-with-andre-drummond-wrts"
            image={placeholder01}
            category="Original"
            mediaType="scrolling"
            title="Growing up in the NBA w/ Andre Drummond"
          />

          <img src={glitch} className="Gif" alt=""/>

          <ContentThumbnail
            href="https://www.uninterrupted.com/watch/HaRXJhcF/we-remember-muhammad-ali"
            video={videoAli}
            mediaType="video"
            category="Documentary"
            title="We Remember Muhammad Ali"
          />

          <img src={placeholder04} className="Gif" alt=""/>
        </div>
        
        <div className="App-col App-col--wide">
          <ContentThumbnail
            href="https://www.uninterrupted.com/watch/va9XUpTV/damari?playlist=12OBU8yRDgckMmAkgyIiKs"
            video={videoDamari}
            mediaType="fan"
            category="Documentary"
            title="Damari Hendrix’s Return to Basketball After Gunshot Wound"
          />

          <BrandHashtag />

          <ContentThumbnail
            href="https://www.uninterrupted.com/"
            image={placeholder03}
            category="Original"
            title="Yasiel  is UNINTERRUPTED"
          />
        </div>
        
        <div className="App-col">
          <Instagram href="https://instagram.com/uninterrupted" />
          
          <ContentThumbnail
            href="https://www.uninterrupted.com/original/5xq9VNLf7aGy4CUMAmcku8/the-carter-effect/watch/QnFrL28S/preview-the-carter-effect"
            image="https://assets-jpcust.jwpsrv.com/thumbnails/juhi5iml-720.jpg"
            category="Documentary"
            title="The Carter Effect"
          />

          <img src={bounce} className="Gif" alt=""/>

          <Instagram href="https://instagram.com/uninterrupted" />
        </div>

      </div>
    </div>
  );
}

/* Example of instagram module with random images
<Instagram images={[
  `https://picsum.photos/400/400?${Math.random()}`,
  `https://picsum.photos/400/400?${Math.random()}`,
  `https://picsum.photos/400/400?${Math.random()}`
]} />
*/